var map = {
	"./A6BEEA6A49DEA262.png": "faa0",
	"./academy-bulb.svg": "02fe",
	"./announcement.svg": "7565",
	"./api-blog.svg": "cb7c",
	"./api-community.svg": "7a67",
	"./api-consultancy.svg": "788e",
	"./api-economy-education.svg": "f0ea",
	"./api-hub.svg": "fc5ef",
	"./api-marketplace.svg": "9500",
	"./api-network.svg": "61d2",
	"./api-product.svg": "853a",
	"./api-world.svg": "14dc",
	"./apiops-cicd/cicd-feature-1.svg": "97a3",
	"./apiops-cicd/cicd-feature-2.svg": "83fa",
	"./apiops-cicd/cicd-feature-3.svg": "513d",
	"./apiops-cicd/cicd-hero.svg": "cec2",
	"./be-user.svg": "f0f8",
	"./ben-about-hero.svg": "b528",
	"./build-portal.svg": "0a23",
	"./career-1.svg": "62f4",
	"./choose-colour.svg": "6a94",
	"./communication.svg": "a2be",
	"./community-apply.svg": "dece",
	"./community.svg": "04ad",
	"./community/community-feature-1.svg": "bc5b",
	"./community/community-feature-2.svg": "3811",
	"./community/community-feature-3.svg": "b445",
	"./community/community-hero.svg": "4782",
	"./construction.svg": "6262",
	"./consumer-apply.svg": "c160",
	"./coupon-hero.svg": "f3f5",
	"./create-launch.svg": "e08a",
	"./enterprise-api-hub-overview.svg": "56e4",
	"./enterprise-hero.svg": "8dfe",
	"./event-resources.svg": "82c4",
	"./events-home copy.svg": "5a1d",
	"./events-home.svg": "dde5",
	"./events.svg": "0763",
	"./giftbox.svg": "ebb8",
	"./home-hero-16by9.svg": "0426",
	"./home-hero.svg": "f76c",
	"./internal-api-hub.svg": "78bc",
	"./learn-api.svg": "6109",
	"./learnapi.svg": "8fae",
	"./lego-1.svg": "270e",
	"./lego-2.svg": "211d",
	"./lego-3.svg": "1b4a",
	"./loading.svg": "49b7",
	"./management/management-cta.svg": "4906",
	"./management/management-feature-1.svg": "e89b",
	"./management/management-feature-2.svg": "2cf1",
	"./management/management-feature-3.svg": "8190",
	"./management/management-hero.svg": "263d",
	"./member-api.svg": "71f4",
	"./monetization/monetization-feature-1.svg": "23f5",
	"./monetization/monetization-feature-3.svg": "d4f3",
	"./monetization/monetization-hero.svg": "0c24",
	"./oah-landing-about.svg": "92bb",
	"./oah-role-developer.svg": "4ea2",
	"./oah-role-enterprise.svg": "8136",
	"./oah-role-provider.svg": "5a8b",
	"./oah-role-startup.svg": "d210",
	"./oah_404.svg": "1046",
	"./partner-api-hub.svg": "e8e9",
	"./portal-generator-hero.svg": "f6b5",
	"./provider-apply.svg": "a18f",
	"./replay-video.svg": "478d",
	"./sample-portal-home.svg": "45fd",
	"./send-bg.svg": "d078",
	"./send.svg": "44c0",
	"./transformations/transformations-feature-1.svg": "e6c6",
	"./transformations/transformations-feature-2.svg": "483c",
	"./transformations/transformations-hero.svg": "c7b2",
	"./trust/trust-cta.svg": "4bce",
	"./trust/trust-feature-1.svg": "c539",
	"./trust/trust-feature-2.svg": "0023",
	"./trust/trust-feature-3.svg": "c51d",
	"./trust/trust-hero.svg": "505b",
	"./upload-file.svg": "72e2",
	"./use-cases/cat-1.svg": "f16f",
	"./use-cases/cat-2.svg": "b208",
	"./use-cases/cat-3.svg": "f031",
	"./use-cases/cat-banner-catalogue.svg": "7c78",
	"./use-cases/cat-banner.svg": "0dba",
	"./use-cases/com-1.svg": "0024",
	"./use-cases/com-2.svg": "2238",
	"./use-cases/com-3.svg": "073b",
	"./use-cases/com-banner-catalogue.svg": "818f",
	"./use-cases/com-banner.svg": "e5f7",
	"./use-cases/edu-1.svg": "55f4",
	"./use-cases/edu-2.svg": "5c53",
	"./use-cases/edu-3.svg": "688f",
	"./use-cases/edu-banner-catalogue.svg": "359c",
	"./use-cases/edu-banner.svg": "df7a",
	"./use-cases/esport-1.svg": "e3de",
	"./use-cases/esport-2.svg": "bd19",
	"./use-cases/esport-3.svg": "cdca",
	"./use-cases/esport-banner-catalogue.svg": "2575",
	"./use-cases/esport-banner.svg": "df67",
	"./use-cases/fs-1.svg": "5e80",
	"./use-cases/fs-2.svg": "fe93",
	"./use-cases/fs-3.svg": "03e1",
	"./use-cases/fs-banner-catalogue.svg": "c669",
	"./use-cases/fs-banner.svg": "ecf3",
	"./use-cases/health-1.svg": "170c",
	"./use-cases/health-2.svg": "4f79",
	"./use-cases/health-3.svg": "54fa",
	"./use-cases/health-banner-catalogue.svg": "6312",
	"./use-cases/health-banner.svg": "dc43",
	"./use-cases/ins-1.svg": "8ab4",
	"./use-cases/ins-2.svg": "1899",
	"./use-cases/ins-3.svg": "67a0",
	"./use-cases/ins-banner-catalogue.svg": "5f0d",
	"./use-cases/ins-banner.svg": "3561",
	"./use-cases/tour-1.svg": "3e84",
	"./use-cases/tour-2.svg": "d7b9",
	"./use-cases/tour-3.svg": "da23",
	"./use-cases/tour-banner-catalogue.svg": "1010",
	"./use-cases/tour-banner.svg": "a097"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5da3";